"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ButtonList(_ref) {
  var items = _ref.items;

  try {
    var handleClose = function handleClose() {
      if (isOpen) {
        setOpen(false);
      }
    };

    var handleOpen = function handleOpen() {
      if (!isOpen) {
        setOpen(true);
      }
    };

    var handleSelect = function handleSelect(cb, event) {
      var selectElement = wrapperRef.current;
      var target = event['target'];

      if (selectElement && selectElement.contains(target)) {
        cb();
        handleClose();
      }
    };

    var wrapperRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        isOpen = _useState2[0],
        setOpen = _useState2[1];

    (0, _react.useEffect)(function () {
      function handleResetState(event) {
        var wrapperElement = wrapperRef['current'];

        if (wrapperElement) {
          var target = event['target'];

          if (!wrapperElement.contains(target)) {
            setOpen(false);
          }
        }
      }

      document.addEventListener('click', handleResetState);
      return function () {
        document.removeEventListener('click', handleResetState);
      };
    }, []);
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: wrapperRef,
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "button.create",
      form: 'with-icon',
      icon: "icon-plus",
      mode: "success",
      onClick: handleOpen
    }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C"), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__control']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['list']
    }, items.map(function (item, index) {
      return item && /*#__PURE__*/_react["default"].createElement("div", {
        "data-locator": item['_data'],
        key: index,
        className: _defaultModule["default"]['list__item'],
        onClick: function onClick(event) {
          return handleSelect(item['onClick'], event);
        }
      }, item['title']);
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ButtonList;
exports["default"] = _default;